var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 2.00065H15.668C16.5846 2.00065 17.3346 2.75065 17.3346 3.66732V12.0007C17.3346 12.9173 16.5846 13.6673 15.668 13.6673H9.83463V7.7L12.1596 10.025L13.3346 8.84167L9.00963 4.5L4.66797 8.84167L5.84297 10.0167L8.16797 7.7V13.6673H2.33464C1.41797 13.6673 0.667969 12.9173 0.667969 12.0007L0.676302 2.00065C0.676302 1.08398 1.41797 0.333984 2.33464 0.333984H7.33464L9.0013 2.00065Z",
    fill: "#8596B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.11f1cc1cf30d13b3702bd03f56d11aec.svg";
export { ForwardRef as ReactComponent };